<!-- 导航直播首页 -->
<template>
  <div>
    <div class="bl-container text-center">
      <div class="search-nav">
        <span class="pointer s1" :class="[liveType == 1 ? 'active' : '']" @click="changeLiveType({ key: 'liveType', val: 1 })">{{$t('lives.taggleLiveStatus[0]')}}</span>
        <span class="pointer s2" :class="[liveType == 2 ? 'active' : '']" @click="changeLiveType({ key: 'liveType', val: 2 })">{{$t('lives.taggleLiveStatus[1]')}}</span>
      </div>
    </div>
    <div class="v-header-box">
      <el-select size="small" v-model="lParty" class="v-select-height-32 m-l-0" @change="selectChange">
        <el-option size="small" v-for="(item, index) in option" :key="index" :label="item.label" :value="item.value"> </el-option>
      </el-select>
      <!-- 时间-人气排序 -->
      <el-select size="small" v-model="desc" class="v-select-height-32 m-l-0" @change="selectChange2">
        <el-option size="small" v-for="(item, index) in option2" :key="index" :label="item.label" :value="item.value"> </el-option>
      </el-select>
      <el-input
        style="width:200px;margin-right:20px"
        size="small"
        clearable
        class="v-select-height-32 font-size-14"
        v-model="keyWord"
        :placeholder="$t('liveKeyWorld')"></el-input>
      <el-date-picker
        style="margin-right:20px"
        size="small"
        v-model="datetimerange"
        type="datetimerange"
        value-format="yyyy-MM-dd HH:mm:ss"
        range-separator="至"
        start-placeholder="请选择开播时间"
        end-placeholder="请选择结束时间">
      </el-date-picker>
      <!-- <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" style="width:200px;margin-right:20px" v-model="liveStartTime" type="datetime" placeholder="请选择开播时间"> </el-date-picker> -->
      <!-- <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" style="width:200px;margin-right:20px" v-model="liveEndTime" type="datetime" placeholder="请选择结束时间"> </el-date-picker> -->
      <el-button size="small" type="primary" icon="el-icon-search" @click="searchLiveName()">{{ $t('homes.searchPlaceHolder') }}</el-button>
    </div>
    <div class="v-router-view-box">
      <!-- ROUTER -VIEW -->
      <router-view></router-view>
    </div>
    <div class="v-live-type-r" v-if="activeArr.length > 0">
        <div :class="[activityType[0] ? '' : 'active', 'pointer']" @click="clickactivityType(0)">
          {{ $t('lives.option[0]') }}
        </div>
        <div
          :class="[activityType[0] == item.id ? 'active' : '', 'pointer']"
          v-for="(item, index) in activeArr"
          :key="index"
          class="ellipsis-2"
          @click="clickactivityType(1,item)">
          {{ item.activityType }}
        </div>
    </div>
    <advertisementVertical :option="$config.advertisement.leftList.live" :leftPosition='true' :top="advertisementTop+'px'"></advertisementVertical>
    <advertisementVertical :option="$config.advertisement.rightList.live" :rightPosition='true' :top="advertisementTop+'px'"></advertisementVertical>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import liveMixin from '@/mixins/live.js'
import advertisementVertical from '@/components/advertisementVertical'
export default {
  mixins: [liveMixin],
  components: {
    advertisementVertical
  },
  data() {
    return {
      advertisementTop: 120,
      lParty: '',
      desc: 0,
      option2: this.$t('select.liveOption'),
      keyWord: '', //搜索 内容
      datetimerange: ''
    }
  },
  computed: {
    ...mapGetters(['subjectType']),
    option() {
      var option = [
        {
          value: 0,
          label: this.$t('lives.option[0]')
        },
        {
          value: 1,
          label: this.$t('lives.option[1]')
        },
        {
          value: 2,
          label: this.$t('lives.option[2]')
        }
      ]
      if (this.subjectType == 'ACTOR') {
        return [
          {
            value: 1,
            label: this.$t('lives.option[1]')
          }
        ]
      }
      return option
    }
  },
  created() {
    this.commitState({
      key: 'orderDesc',
      val: this.desc
    })
    if (this.subjectType == 'ACTOR') {
      this.lParty = 1
    } else {
      this.lParty = 0
    }
    this.getActivityType()
    window.PC.$RangersEventLive('view', {type: this.liveType})
  },
  methods:{
    clickactivityType(type,data){
      window.PC.$RangersEventLive('search', {type: this.liveType})
      if(type == 0) {
        this.commitAndLoadData(1,{ key: 'activityType', val: [] })
        this.commitAndLoadData(2,{ key: 'activityType', val: [] })
      } else {
        this.commitAndLoadData(1,{ key: 'activityType', val: [data.id] })
        this.commitAndLoadData(2,{ key: 'activityType', val: [data.id] })
      }
    }
  },
}
</script>
<style lang="stylus" scoped>
.search-nav {
  margin-top: 24px;
}

.v-header-box{
    width:100%;
    max-width:$container-width;
    padding-left: 15px;
    padding-right: 15px;
    margin:0 auto 24px;
    .margin0{margin:0;}
    .el-select{
      margin:0 24px 0 12px;
    }
    span{
      margin-right:24px;
      font-size:16px;
    }
  }
  .active{
    color:$color-main;
  }
  .v-router-view-box{
    max-width:$container-width;
    padding-left: 15px;
    padding-right: 15px;
    margin:0 auto;
    position:relative;
    padding-bottom: 60px;
  }

  .v-live-type-r{
      width:250px;
      padding:12px;
      position: fixed;
      right: 15px;
      top: 260px;
      background:$color-white;
      box-shadow: 0 0 20px $color-black-05
      z-index:5

      >div{
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      >div + div{
        margin-top: 12px;
        cursor:pointer;
      }
    }
</style>
